module.exports = __webpack_public_path__ + "media/slider/previous-055f19ed.png";